import SocialsTimeline from "../components/SocialsTimeline";
import { wallId } from "../config";

const SocialWall = () => {
  document.body.style.backgroundColor = "#3D82C4";
  return <SocialsTimeline wallId={wallId} />;
};

export default SocialWall;
